import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import * as PageResponsive from "components/utility/page-responsive/PageResponsive";
import ImageLock from "components/utility/images/ImageLock";
import ImageUnlock from "components/utility/images/ImageUnlock";
import ImageEmployeeLock from "components/utility/images/ImageEmployeeLock";
import TooltipButton from "components/utility/tooltip/TooltipButton";

class ContentPageMetadataTooltipContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLocked: false,
			isVisible: false,
			isDesktop: true
		};
	}
	componentDidMount() {
		window.addEventListener("load", this.onResize);
		window.addEventListener("resize", this.onResize);
	}
	UNSAFE_componentWillMount() {
		window.removeEventListener("load", this.onResize);
		window.removeEventListener("resize", this.onResize);
	}
	onResize = () => {
		PageResponsive.isDesktop()
			? this.setState({ isDesktop: true })
			: this.setState({ isDesktop: false });
	};
	handleWindowClick = (e) => {
		if (!e || !e.target) return;

		let currentElement = e.target;
		while (currentElement) {
			if (currentElement.classList.contains("info-popup-content")) return;
			currentElement = currentElement.parentElement;
		}
		this.setState({
			isLocked: false,
			isVisible: false
		});
		window.removeEventListener("click", this.handleWindowClick);
	};
	toggleLocked = () => {
		this.setState({
			isLocked: !this.state.isLocked,
			isVisible: !this.state.isLocked
		});
		window.requestAnimationFrame(() => {
			if (this.state.isLocked) {
				window.addEventListener("click", this.handleWindowClick);
			} else {
				window.removeEventListener("click", this.handleWindowClick);
			}
		});
	};
	getAccessType = () => {
		let type = this.props.data.accessType.toLowerCase();
		let imageIcon = <ImageLock />;
		switch (type) {
			case "public":
				imageIcon = <ImageUnlock />;
				break;
			case "client":
				imageIcon = <ImageLock />;
				break;
			case "employee":
				imageIcon = <ImageEmployeeLock />;
				break;
			case "xlink":
				imageIcon = "";
				break;
			default:
				break;
		}
		return imageIcon;
	};
	setVisible(state) {
		this.setState({
			isVisible: state
		});
	}
	render() {
		const { data = { title: "", content: "", format: "", accessType: "", accessHoverText: "" } } =
			this.props;
		const { isDesktop } = this.state;
		return (
			<div
				className={`pdf--ignore content-page-metadata-tooltip  ${
					isDesktop ? "content-page-metadata-tooltip-desktop" : ""
				}`}
			>
				<div className="content-page-metadata-tooltip-metaWrapper">
					{data.accessType ? (
						<Fragment>
							<TooltipButton
								className="content-page-metadata-tooltip-access"
								id={data.accessType}
								content={data.accessHoverText}
								position="bottom"
								mobilePosition="bottom"
								tooltipPosition="right"
								mobiletoolPosition="right"
								clickable={true}
							>
								{this.getAccessType()}
							</TooltipButton>
							{data.accessType === "xlink" ? (
								""
							) : (
								<div className="content-page-metadata-tooltip-divider">|</div>
							)}
						</Fragment>
					) : null}
					<TooltipButton
						id={data.content}
						content={data.content}
						position="bottom"
						tooltipPosition="right"
						clickable={true}
						dataLabel={data.title}
						dataQA="content-page-metadata-access-type"
					>
						{data.title}
					</TooltipButton>
				</div>

				{data.format ? (
					<div
						className={`content-page-metadata-format t-body-sm ${
							isDesktop ? "content-page-metadata-format-desktop" : ""
						}`}
					>
						<div className="content-page-metadata-tooltip-divider">|</div>
						{data.format}
					</div>
				) : null}
			</div>
		);
	}
	static propTypes = {
		data: PropTypes.shape({
			title: PropTypes.string,
			content: PropTypes.string,
			format: PropTypes.string
		})
	};
}

export default ContentPageMetadataTooltipContent;
